export default "__VITE_ASSET__DzeAzKK0__"